<style lang="less" scoped>
  html, body {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .home-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(
      circle at center,
      #0f2547 0%,
      #091429 50%,
      #050c1a 100%
    );
    position: relative;
    overflow: hidden;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    padding: 20px;
    margin: 0;
  }

  /* 漂浮光点粒子 */
  .tech-grid {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      radial-gradient(circle, rgba(0, 191, 255, 0.3) 1px, transparent 1px),
      radial-gradient(circle, rgba(0, 191, 255, 0.2) 1px, transparent 1px),
      radial-gradient(circle, rgba(0, 191, 255, 0.4) 1.5px, transparent 1.5px);
    background-size: 250px 250px, 180px 180px, 120px 120px;
    background-position: 0 0, 40px 60px, 130px 270px;
    opacity: 0.6;
    z-index: 1;
    animation: float-particles 20s ease-in-out infinite;
  }

  .welcome-card {
    position: relative;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: transparent;
    padding: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    animation: fadeIn 0.8s ease-out;
    overflow: hidden;

    @media (max-width: 768px) {
      padding: 40px 25px;
      border-radius: 20px;
    }
  }

  .tech-line {
    position: relative;
    width: 120px;
    height: 3px;
    background: linear-gradient(90deg, transparent, #00bfff, transparent);
    margin-bottom: 35px;
    border-radius: 2px;
    box-shadow: 0 0 15px rgba(0, 191, 255, 0.6);
  }

  .welcome-icon {
    width: 190px;
    height: 190px;
    object-fit: contain;
    margin: 0 0 35px 0;
    animation: float 3s ease-in-out infinite;
    filter: drop-shadow(0 0 20px rgba(0, 191, 255, 0.5));
    position: relative;
    z-index: 15;

    @media (max-width: 768px) {
      width: 100px;
      height: 100px;
      margin: 15px 0 20px 0;
    }
  }

  /* 顶部：球(机器人) */
  .hero-row {
    width: 100%;
    max-width: 980px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    position: relative;
    z-index: 15;

    @media (max-width: 992px) {
      flex-direction: column;
      margin-bottom: 6px;
    }
  }

  .hero-left {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    width: 100%;
  }

  .version-glow-card {
    position: relative;
    border-radius: 18px;
    padding: 10px 12px;
    overflow: hidden;
    backdrop-filter: blur(14px);
    background: linear-gradient(160deg, rgba(9, 20, 41, 0.55), rgba(15, 35, 70, 0.35));
    box-shadow:
      0 10px 30px rgba(0, 0, 0, 0.35),
      0 0 28px rgba(0, 191, 255, 0.16);
    border: 1px solid rgba(0, 191, 255, 0.18);
    transition: all 0.35s ease;
  }

  .version-glow-card::before {
    content: '';
    position: absolute;
    inset: -2px;
    background: conic-gradient(
      from 180deg,
      rgba(0, 191, 255, 0.0),
      rgba(0, 255, 255, 0.55),
      rgba(138, 43, 226, 0.45),
      rgba(0, 191, 255, 0.55),
      rgba(0, 191, 255, 0.0)
    );
    filter: blur(14px);
    opacity: 0.42;
    z-index: 0;
    animation: glow-pulse 2.8s ease-in-out infinite;
  }

  .version-glow-card::after {
    content: '';
    position: absolute;
    inset: 1px;
    border-radius: 17px;
    background: linear-gradient(160deg, rgba(9, 20, 41, 0.72), rgba(10, 25, 50, 0.55));
    z-index: 1;
  }

  .version-glow-card:hover {
    transform: translateY(-3px);
    border-color: rgba(0, 255, 255, 0.35);
    box-shadow:
      0 14px 36px rgba(0, 0, 0, 0.42),
      0 0 34px rgba(0, 191, 255, 0.24);
  }

  .version-glow-card__content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .version-glow-card__icon {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(0, 191, 255, 0.18), rgba(138, 43, 226, 0.10));
    border: 1px solid rgba(0, 191, 255, 0.22);
    box-shadow: inset 0 0 14px rgba(0, 191, 255, 0.10);
    flex-shrink: 0;
  }

  .version-glow-card__icon .card-icon {
    font-size: 18px;
    color: #e6fbff;
    text-shadow: 0 0 10px rgba(0, 255, 255, 0.45);
  }

  .version-glow-card__meta {
    flex: 1;
    min-width: 0;
  }

  .version-glow-card__label {
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 1.6px;
    color: rgba(100, 181, 246, 0.92);
    text-transform: uppercase;
    margin-bottom: 4px;
    text-shadow: 0 0 6px rgba(100, 181, 246, 0.22);
  }

  .version-glow-card__value {
    font-size: 15px;
    font-weight: 800;
    color: #ffffff;
    letter-spacing: 0.4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-shadow:
      0 0 12px rgba(0, 191, 255, 0.45),
      0 0 22px rgba(138, 43, 226, 0.20);
  }

  .version-glow-card__sub {
    margin-top: 4px;
    font-size: 11px;
    color: rgba(100, 181, 246, 0.75);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .version-glow-card__sub.is-error {
    color: rgba(245, 108, 108, 0.95);
    text-shadow: 0 0 10px rgba(245, 108, 108, 0.22);
  }

  @keyframes glow-pulse {
    0% {
      opacity: 0.28;
      filter: blur(14px);
    }
    50% {
      opacity: 0.52;
      filter: blur(18px);
    }
    100% {
      opacity: 0.28;
      filter: blur(14px);
    }
  }

  .welcome-title {
    font-size: 48px;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 16px 0;
    letter-spacing: -0.5px;
    text-shadow: 0 0 20px rgba(0, 191, 255, 0.5);
    position: relative;
    z-index: 15;

    @media (max-width: 768px) {
      font-size: 40px;
    }
  }

  .welcome-subtitle {
    font-size: 20px;
    color: #00bfff;
    margin: 0 0 12px 0;
    line-height: 1.6;
    font-weight: 500;
    letter-spacing: 0;
    position: relative;
    z-index: 15;

    @media (max-width: 768px) {
      font-size: 18px;
    }
  }

  .welcome-description {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 50px 0;
    line-height: 1.7;
    font-weight: 400;
    letter-spacing: 0;
    position: relative;
    z-index: 15;
  }

  /* 新的仪表盘风格状态栏 */
  .stats-grid {
    display: grid;
    grid-template-columns: 0.65fr 0.65fr 0.65fr 1.35fr;
    gap: 16px;
    width: 100%;
    max-width: 1480px;
    margin: 30px 0;
    position: relative;
    z-index: 15;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .version-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;

    .card-label {
      margin-bottom: 0;
    }
  }

  .version-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    flex-shrink: 0;

    &.match {
      color: #52c41a;
      background: rgba(82, 196, 26, 0.16);
      border: 1px solid rgba(82, 196, 26, 0.45);
      box-shadow: 0 0 10px rgba(82, 196, 26, 0.22);
    }

    &.mismatch {
      color: #faad14;
      background: rgba(250, 173, 20, 0.16);
      border: 1px solid rgba(250, 173, 20, 0.45);
      box-shadow: 0 0 10px rgba(250, 173, 20, 0.22);
    }
  }

  .version-pair {
    margin-top: 6px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .version-line {
    display: grid;
    grid-template-columns: 42px 1fr;
    align-items: center;
    column-gap: 10px;
    font-size: 14px;
    color: rgba(100, 181, 246, 0.78);
  }

  .version-line .k {
    opacity: 0.9;
    flex: 0 0 auto;
  }

  .version-line .v {
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    line-height: 1.35;
    padding: 5px 10px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.14);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.08),
      0 2px 8px rgba(0, 0, 0, 0.12);
  }

  .version-line.is-error {
    color: rgba(245, 108, 108, 0.95);
  }

  /* 版本文本颜色区分：前端/后端 + 标签/值 */
  .version-line.is-front .k {
    color: rgba(120, 220, 255, 0.92);
    text-shadow: 0 0 8px rgba(0, 191, 255, 0.22);
  }
  .version-line.is-front .v {
    color: rgba(235, 252, 255, 0.95);
    text-shadow: 0 0 10px rgba(0, 191, 255, 0.20);
    background: rgba(0, 191, 255, 0.10);
    border-color: rgba(0, 191, 255, 0.22);
  }

  .version-line.is-back .k {
    color: rgba(190, 140, 255, 0.92);
    text-shadow: 0 0 8px rgba(138, 43, 226, 0.22);
  }
  .version-line.is-back .v {
    color: rgba(255, 246, 235, 0.95);
    text-shadow: 0 0 10px rgba(138, 43, 226, 0.18);
    background: rgba(138, 43, 226, 0.10);
    border-color: rgba(138, 43, 226, 0.22);
  }

  .stat-card {
    background: linear-gradient(145deg, rgba(18, 42, 82, 0.78), rgba(10, 25, 50, 0.78));
    border: 1px solid rgba(0, 191, 255, 0.22);
    border-radius: 16px;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 20px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    backdrop-filter: blur(12px);
    position: relative;
    overflow: hidden;
    min-height: 110px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28);

    &:hover {
      filter: saturate(1.08) brightness(1.05);
      border-color: rgba(0, 191, 255, 0.4);
      transform: translateY(-4px);
      box-shadow: 0 12px 26px rgba(0, 0, 0, 0.32);

      .card-icon {
        transform: scale(1.1) rotate(5deg);
        color: #fff;
        text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
      }
      
      .robot-card-img {
        transform: scale(1.1);
      }
    }
  }

  .stat-card.system-card,
  .stat-card.robot-card,
  .stat-card.lang-card {
    background: linear-gradient(145deg, rgba(14, 52, 96, 0.85), rgba(11, 31, 60, 0.80));
    padding: 14px 16px;
    gap: 14px;
    min-height: 92px;
    border-radius: 14px;

    .card-icon-wrapper,
    .robot-icon-wrapper {
      width: 46px;
      height: 46px;
    }

    .card-icon {
      font-size: 22px;
    }

    .card-label {
      font-size: 11px;
      letter-spacing: 1.2px;
      margin-bottom: 4px;
    }

    .card-value {
      font-size: 18px;
    }

    .metric-value {
      font-size: 24px;
    }

    .metric-unit,
    .metric-sub {
      font-size: 11px;
    }
  }

  .stat-card.version-card {
    background: linear-gradient(145deg, rgba(14, 52, 96, 0.85), rgba(11, 31, 60, 0.80));
  }

  .card-icon-wrapper {
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(0, 191, 255, 0.1), rgba(0, 191, 255, 0.05));
    border-radius: 50%;
    border: 1px solid rgba(0, 191, 255, 0.2);
    box-shadow: inset 0 0 10px rgba(0, 191, 255, 0.05);
    flex-shrink: 0;
  }

  /* 统一机器人图标样式 */
  .robot-icon-wrapper {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(0, 191, 255, 0.15), rgba(0, 191, 255, 0.05));
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(0, 191, 255, 0.2);
  }

  .robot-card-img {
    width: 70%;
    height: 70%;
    object-fit: contain;
    transition: all 0.4s ease;
    filter: drop-shadow(0 0 5px rgba(0, 191, 255, 0.3));
  }

  .card-icon {
    font-size: 26px;
    color: #00bfff;
    transition: all 0.4s ease;
  }

  .card-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .card-label {
    font-size: 13px;
    color: #64b5f6; /* 冰蓝色，比之前的灰白更有科技感 */
    text-transform: uppercase;
    letter-spacing: 1.5px;
    margin-bottom: 6px;
    font-weight: 700;
    text-shadow: 0 0 5px rgba(100, 181, 246, 0.3);
  }

  .card-value {
    font-size: 22px;
    font-weight: 700;
    color: #ffffff;
    /* 增强发光质感 */
    text-shadow: 
      0 0 10px rgba(0, 191, 255, 0.6),
      0 0 20px rgba(0, 191, 255, 0.3);
    letter-spacing: 0.5px;
    font-family: 'Segoe UI', sans-serif;

    &.status-ok {
      /* 青白色高亮，带更强的光晕 */
      color: #e0f7fa; 
      text-shadow: 
        0 0 10px rgba(0, 255, 255, 0.6),
        0 0 20px rgba(0, 255, 255, 0.3);
    }
  }
  
  .card-sub-value {
    font-size: 12px;
    color: rgba(100, 181, 246, 0.6); /* 即使是辅助文字也带一点蓝调 */
    margin-top: 4px;
    font-weight: 500;
  }

  /* 机器人卡片特有样式 */
  .robot-metrics {
    margin-bottom: 6px;
  }

  .metric-main {
    display: flex;
    align-items: baseline;
    gap: 4px;
    margin-bottom: 2px;
  }

  .metric-value {
    font-size: 28px;
    font-weight: 700;
    /* 渐变文字效果 */
    background: linear-gradient(180deg, #ffffff 0%, #00bfff 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    /* 兼容性回退颜色 */
    color: #00bfff;
    line-height: 1;
    filter: drop-shadow(0 0 5px rgba(0, 191, 255, 0.4));
  }

  .metric-unit {
    font-size: 12px;
    color: #64b5f6;
    opacity: 0.9;
    font-weight: 600;
    margin-left: 2px;
  }

  .metric-sub {
    font-size: 12px;
    color: rgba(176, 190, 217, 0.8);
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;

    .divider {
      color: rgba(0, 191, 255, 0.3);
      font-size: 10px;
    }
    
    .sub-item {
      transition: color 0.3s;
    }

    .sub-item:hover {
      color: #fff;
    }
    
    .offline {
      color: #ff8a80; /* 柔和的警示红 */
      text-shadow: 0 0 5px rgba(255, 82, 82, 0.4);
    }
  }

  .mini-progress-bar {
    width: 100%;
    height: 4px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
    overflow: hidden;
    margin-top: 4px;
  }

  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #00bfff, #00ffaa);
    transition: width 0.5s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }


  @keyframes float-particles {
    0%, 100% {
      background-position: 0 0, 40px 60px, 130px 270px;
      opacity: 0.6;
    }
    25% {
      background-position: 100px 50px, 140px 110px, 230px 320px;
      opacity: 0.7;
    }
    50% {
      background-position: 50px 100px, 90px 160px, 180px 370px;
      opacity: 0.5;
    }
    75% {
      background-position: -50px 50px, -10px 110px, 80px 320px;
      opacity: 0.7;
    }
  }

  /* 快捷菜单区域 */
  .quick-menu-section {
    width: 100%;
    max-width: 900px;
    position: relative;
    z-index: 15;
  }

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 0 10px;
  }

  .section-title {
    font-size: 18px;
    color: #00bfff;
    font-weight: 600;
  }

  .settings-icon {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      color: #00bfff;
      transform: rotate(90deg);
    }
  }

  .quick-menu-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 15px;
  }

  .quick-menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 15px;
    background: rgba(15, 30, 60, 0.5);
    border: 1px solid rgba(0, 191, 255, 0.3);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s;
    backdrop-filter: blur(10px);

    &:hover {
      background: rgba(15, 30, 60, 0.7);
      border-color: #00bfff;
      box-shadow: 0 0 20px rgba(0, 191, 255, 0.3);
      transform: translateY(-3px);
    }

    .menu-icon {
      width: 40px;
      height: 40px;
      margin-bottom: 10px;
      color: #00bfff;
    }

    .menu-title {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      text-align: center;
      word-break: break-word;
    }
  }

  .add-menu-btn {
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 15px 30px;
    background: rgba(0, 191, 255, 0.1);
    border: 2px dashed rgba(0, 191, 255, 0.4);
    border-radius: 12px;
    color: #00bfff;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    z-index: 15;

    &:hover {
      background: rgba(0, 191, 255, 0.2);
      border-color: #00bfff;
      box-shadow: 0 0 20px rgba(0, 191, 255, 0.3);
    }
  }

  /* 设置弹窗样式 */
  .settings-content {
    h4 {
      margin-top: 20px;
      margin-bottom: 15px;
      color: #333;
      font-size: 15px;
      font-weight: 600;
    }
  }

  .current-menus {
    margin-bottom: 30px;
  }

  .menus-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    h4 {
      margin: 0;
    }

    .menu-count {
      font-size: 14px;
      color: #2d8cf0;
      font-weight: 600;
    }
  }

  .menu-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    min-height: 40px;

    .empty-tip {
      color: #999;
      font-size: 14px;
      font-style: italic;
    }
  }

  .search-input {
    margin-bottom: 15px;
  }

  .menu-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
    max-height: 400px;
    overflow-y: auto;
    padding: 5px;
  }

  .menu-card {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px 10px;
    border: 1px solid #dcdee2;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    background: #fff;

    &:hover {
      border-color: #2d8cf0;
      box-shadow: 0 2px 12px rgba(45, 140, 240, 0.2);
      transform: translateY(-2px);
    }

    &.is-selected {
      border-color: #2d8cf0;
      background: rgba(45, 140, 240, 0.05);
    }

    &.is-disabled {
      opacity: 0.5;
      cursor: not-allowed;

      &:hover {
        border-color: #dcdee2;
        box-shadow: none;
        transform: none;
      }
    }

    .card-icon {
      width: 32px;
      height: 32px;
      margin-bottom: 8px;
      color: #2d8cf0;
    }

    .card-title {
      font-size: 13px;
      color: #333;
      text-align: center;
      word-break: break-word;
    }

    .check-icon {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 20px;
      color: #19be6b;
    }
  }

</style>
<template>
  <div class="home-container">
    <!-- 动态背景元素 -->
    <div class="tech-grid"></div>
    
    <div class="welcome-card">
      <div class="hero-row">
        <div class="hero-left">
          <img class="welcome-icon" :src="robotImage" alt="Robot" />
        </div>
      </div>
      <h1 class="welcome-title">{{ getUserName }}</h1>
      <p class="welcome-subtitle">{{ subtitleText }}</p>
      
      <div class="stats-grid">
        <!-- 平台状态卡片 -->
        <div class="stat-card system-card">
          <div class="card-icon-wrapper">
            <Icon type="md-checkmark-circle" class="card-icon" />
          </div>
          <div class="card-content">
            <div class="card-label">{{ platformStatusLabel }}</div>
            <div class="card-value status-ok">{{ platformStatusText }}</div>
          </div>
        </div>

        <!-- 机器人状态卡片 -->
        <div class="stat-card robot-card">
          <div class="card-icon-wrapper robot-icon-wrapper">
            <img :src="robotCardImage" alt="Robot" class="robot-card-img" />
          </div>
          <div class="card-content">
            <div class="card-label">{{ robotStatusLabel }}</div>
            <div class="robot-metrics">
              <div class="metric-main">
                <span class="metric-value">{{ onlineCount }}</span>
                <span class="metric-unit">{{ langMap.online[this.lang] }}</span>
              </div>
              <div class="metric-sub">
                <span class="sub-item">{{ $translate('home_robot_total') }}: {{ totalRobots }}</span>
                <span class="divider">|</span>
                <span class="sub-item offline">{{ langMap.offline[this.lang] }}: {{ offlineCount }}</span>
              </div>
            </div>
            <!-- 简单的进度条 -->
            <div class="mini-progress-bar">
              <div class="progress-fill" :style="{ width: onlinePercentage + '%' }"></div>
            </div>
          </div>
        </div>

        <!-- 语言卡片 -->
        <div class="stat-card lang-card">
          <div class="card-icon-wrapper">
            <Icon type="md-globe" class="card-icon" />
          </div>
          <div class="card-content">
            <div class="card-label">{{ languageLabel }}</div>
            <div class="card-value">{{ currentLanguage }}</div>
          </div>
        </div>

        <!-- 版本卡片（第4个，一行4个） -->
        <div class="stat-card version-card" style="max-width: 450px;">
          <div class="card-icon-wrapper">
            <Icon type="md-git-branch" class="card-icon" />
          </div>
          <div class="card-content">
            <div class="version-card-header">
              <div class="card-label">{{ $translate('home_version_info') }}</div>
              <span
                v-if="versionMatchStatus"
                class="version-status-badge"
                :class="versionMatchStatus"
              >
                <Icon :type="versionMatchStatus === 'match' ? 'md-checkmark-circle' : 'md-alert'" />
                <span>{{ versionMatchStatusText }}</span>
              </span>
            </div>
            <div class="version-pair">
              <div class="version-line is-front">
                <span class="k">{{ $translate('home_version_front') }}</span>
                <span class="v">{{ gitBranch || '--' }}</span>
              </div>
              <div
                class="version-line is-back"
                :class="{ 'is-error': !backendVersionLoading && !!backendVersionError }"
              >
                <span class="k">{{ $translate('home_version_back') }}</span>
                <span class="v">
                  <template v-if="backendVersionLoading">{{ $translate('home_version_loading') }}</template>
                  <template v-else-if="backendVersionError">{{ backendVersionError }}</template>
                  <template v-else>{{ backendPlatformVersion || '--' }}</template>
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- 快捷菜单入口 -->
      <div class="quick-menu-section" v-if="quickMenus.length > 0">
        <div class="section-header">
          <span class="section-title">{{ $translate('home_quick_menu') }}</span>
          <Tooltip :content="$translate('home_quick_menu_settings')" placement="top">
            <Icon type="md-settings" class="settings-icon" @click="showSettingsModal = true" />
          </Tooltip>
        </div>
        <div class="quick-menu-list">
          <div 
            v-for="menu in quickMenus" 
            :key="menu.name"
            class="quick-menu-item"
            @click="navigateTo(menu)"
          >
            <svg-icon name="quickMenu" class="menu-icon"></svg-icon>
            <span class="menu-title">{{ getMenuTitle(menu) }}</span>
          </div>
        </div>
      </div>

      <!-- 设置按钮（无快捷菜单时显示） -->
      <div class="add-menu-btn" v-else @click="showSettingsModal = true">
        <Icon type="md-add" />
        <span>{{ $translate('home_add_quick_menu') }}</span>
      </div>
    </div>

    <!-- 快捷菜单设置弹窗 -->
    <Modal
      v-model="showSettingsModal"
      :title="$translate('home_quick_menu_settings')"
      width="700"
      :footer-hide="true"
    >
      <div class="settings-content">
        <Alert type="warning" show-icon>
          {{ $translate('home_quick_menu_clear_cache_warning') }}
        </Alert>
        
        <div class="current-menus">
          <div class="menus-header">
            <h4>{{ $translate('home_current_quick_menus') }}</h4>
            <span class="menu-count">{{ quickMenus.length }} / {{ maxQuickMenus }}</span>
          </div>
          <div class="menu-tags">
            <Tag 
              v-for="menu in quickMenus" 
              :key="menu.name"
              closable
              @on-close="removeQuickMenu(menu.name)"
              color="primary"
            >
              {{ getMenuTitle(menu) }}
            </Tag>
            <span v-if="quickMenus.length === 0" class="empty-tip">{{ $translate('home_no_quick_menus') }}</span>
          </div>
        </div>

        <div class="available-menus">
          <h4>{{ $translate('home_available_menus') }}</h4>
          <Input 
            v-model="searchKeyword" 
            :placeholder="$translate('home_search_menu')"
            search
            clearable
            class="search-input"
          />
          <div class="menu-grid">
            <div 
              v-for="route in filteredAvailableRoutes" 
              :key="route.name"
              class="menu-card"
              :class="{ 'is-selected': isQuickMenu(route.name), 'is-disabled': !isQuickMenu(route.name) && quickMenus.length >= maxQuickMenus }"
              @click="toggleQuickMenu(route)"
            >
              <svg-icon name="quickMenu" class="card-icon"></svg-icon>
              <span class="card-title">{{ getRouteTitle(route) }}</span>
              <Icon 
                v-if="isQuickMenu(route.name)" 
                type="md-checkmark-circle" 
                class="check-icon"
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';
import robotImage from '@/assets/images/robotCommon/robot-2.png';
import robotCardImage from '@/assets/images/robotCommon/robot-1.png';
import langMap from '@/utils/language';

let gitBranch = '0.0.10';
let gitBuildTime = '';
try {
  const gitInfo = require('@/config/git-info.js').default;
  if (gitInfo && gitInfo.branch) {
    gitBranch = gitInfo.branch;
  }
  if (gitInfo && gitInfo.buildTime) {
    gitBuildTime = gitInfo.buildTime;
  }
} catch (e) {
  // use default version
}

const MAX_QUICK_MENUS = 5;

export default {
  name: 'home',
  data() {
    return {
      robotImage: robotImage,
      robotCardImage: robotCardImage,
      gitBranch: gitBranch,
      gitBuildTime: gitBuildTime,
      langMap: langMap,
      quickMenus: [],
      showSettingsModal: false,
      searchKeyword: '',
      maxQuickMenus: MAX_QUICK_MENUS,
      robotList: [],
      robotStatusLoading: false,
      backendPlatformVersion: '',
      backendBuildTime: '',
      backendVersionLoading: false,
      backendVersionError: '',
    };
  },
  mounted() {
    this.loadQuickMenus();
    this.loadRobotStatus();
    this.loadBackendVersion();
  },
  watch: {
    // 监听用户切换
    storageKey(newVal, oldVal) {
      if (newVal !== oldVal) {
        // 用户切换时重新加载该用户的快捷菜单
        this.loadQuickMenus();
      }
    },
    // 监听sysMenulist变化（语言切换或菜单更新）
    sysMenulist: {
      handler(newVal, oldVal) {
        // sysMenulist 更新时，重新加载快捷菜单以获取最新的标题
        if (newVal && newVal.length > 0) {
          this.loadQuickMenus();
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
      sysMenulist: state => state.app.sysMenulist,
    }),
    // 根据用户ID生成存储key
    storageKey() {
      const userInfo = this.$store.state.user.userInfo;
      console.log(userInfo)
      const userId = userInfo && userInfo.userId ? userInfo.userId : 'default';
      return `home_quick_menus_${userId}`;
    },
    getUserName() {
      const userInfo = this.$store.state.user.userInfo;
      const greeting = langMap.home_welcome_title[this.lang] || 'Welcome';
      if (userInfo && userInfo.name) {
        return `${greeting}, ${userInfo.name}!`;
      }
      return greeting;
    },
    currentLanguage() {
      return this.lang === 'zh' ? '中文' : 'English';
    },
    subtitleText() {
      return langMap.home_welcome_subtitle[this.lang];
    },
    statusLabel() {
      return langMap.home_status[this.lang];
    },
    readyText() {
      return langMap.home_ready[this.lang];
    },
    platformStatusLabel() {
      return langMap.home_platform_status[this.lang];
    },
    platformStatusText() {
      return langMap.home_system_normal[this.lang];
    },
    versionLabel() {
      return langMap.home_version[this.lang];
    },
    languageLabel() {
      return langMap.home_language[this.lang];
    },
    versionText() {
      return this.gitBranch;
    },
    versionMatchStatus() {
      if (this.backendVersionLoading || this.backendVersionError) {
        return null;
      }
      const front = (this.gitBranch || '').trim();
      const back = (this.backendPlatformVersion || '').trim();
      if (!front || !back || front === '--' || back === '--') {
        return null;
      }
      return this.isVersionMatched(front, back) ? 'match' : 'mismatch';
    },
    versionMatchStatusText() {
      if (!this.versionMatchStatus) {
        return '';
      }
      return this.versionMatchStatus === 'match'
        ? this.$translate('home_version_match')
        : this.$translate('home_version_mismatch');
    },
    robotStatusLabel() {
      return langMap.home_robot_status[this.lang] || (this.lang === 'zh' ? '机器人' : 'Robot');
    },
    onlineCount() {
      return this.robotList.filter(robot => robot.onlineStatus).length;
    },
    offlineCount() {
      return this.robotList.filter(robot => !robot.onlineStatus).length;
    },
    totalRobots() {
      return this.robotList.length;
    },
    onlinePercentage() {
      if (this.totalRobots === 0) return 0;
      return Math.round((this.onlineCount / this.totalRobots) * 100);
    },
    robotStatusText() {
      return `${this.onlineCount} ${this.lang === 'zh' ? '在线' : 'online'} / ${this.offlineCount} ${this.lang === 'zh' ? '离线' : 'offline'}`;
    },
    // 获取所有可用的菜单（根据父级菜单的showFlag控制是否显示子菜单）
    availableRoutes() {
      const routes = [];
      const excludeNames = ['_home', 'home', 'login', 'external-login', 'error_401', 'error_500', 'error_404', 'debug-tools', 'trackHistory'];
      const excludePaths = ['/lol']; // 隐藏的路径列表
      
      if (!this.sysMenulist || this.sysMenulist.length === 0) {
        return routes;
      }
      
      // 遍历 sysMenulist 获取菜单
      this.sysMenulist.forEach(menu => {
        const hasChildren = menu.children && menu.children.length > 0;
        const parentShowFlag = menu.showFlag; // 0表示不显示子菜单，1表示显示子菜单
        
        // 当 showFlag=1 时显示子菜单
        if (parentShowFlag === 1 && hasChildren) {
          menu.children.forEach(child => {
            if (child.name && !excludeNames.includes(child.name)) {
              const route = this.findRouteByName(child.name);
              if (route && !excludePaths.includes(route.path)) { // 检查是否应该隐藏
                routes.push({
                  name: child.name,
                  title: child.title,
                  path: route.path,
                  fullPath: route.fullPath || route.path,
                  isChild: true,
                  parentName: menu.name,
                  parentTitle: menu.title
                });
              }
            }
          });
        } else if (parentShowFlag === 0 || !hasChildren) {
          // 当 showFlag=0 或没有子菜单时，显示父级菜单
          if (menu.name && !excludeNames.includes(menu.name)) {
            const route = this.findRouteByName(menu.name);
            if (route && !excludePaths.includes(route.path)) { // 检查是否应该隐藏
              routes.push({
                name: menu.name,
                title: menu.title,
                path: route.path,
                fullPath: route.path,
                isParent: true,
                children: menu.children
              });
            }
          }
        }
      });
      
      return routes;
    },
    // 根据搜索关键词过滤路由
    filteredAvailableRoutes() {
      if (!this.searchKeyword) {
        return this.availableRoutes;
      }
      const keyword = this.searchKeyword.toLowerCase();
      return this.availableRoutes.filter(route => {
        const title = this.getRouteTitle(route).toLowerCase();
        return title.includes(keyword) || (route.name && route.name.toLowerCase().includes(keyword));
      });
    },
  },
  methods: {
    extractComparableVersion(versionStr) {
      if (!versionStr) {
        return '';
      }
      const str = String(versionStr).trim();
      const semver3 = str.match(/(?:^|[^0-9])(\d+\.\d+\.\d+)(?:[^0-9]|$)/);
      if (semver3) {
        return semver3[1];
      }
      const semver2 = str.match(/(?:^|[^0-9])(\d+\.\d+)(?:[^0-9]|$)/);
      if (semver2) {
        return semver2[1];
      }
      return str.toLowerCase();
    },
    isVersionMatched(frontRaw, backRaw) {
      const front = (frontRaw || '').trim();
      const back = (backRaw || '').trim();
      if (!front || !back) {
        return false;
      }

      const frontLower = front.toLowerCase();
      const backLower = back.toLowerCase();
      if (frontLower === backLower) {
        return true;
      }
      if (backLower.includes(frontLower) || frontLower.includes(backLower)) {
        return true;
      }

      const frontVer = this.extractComparableVersion(front);
      const backVer = this.extractComparableVersion(back);
      if (frontVer && backVer && frontVer === backVer) {
        return true;
      }
      if (frontVer && backLower.includes(frontVer)) {
        return true;
      }
      if (backVer && frontLower.includes(backVer)) {
        return true;
      }

      return false;
    },
    // 加载机器人状态
    loadRobotStatus() {
      this.robotStatusLoading = true;
      api.getData('robot-server/robot/list/all').then(response => {
        this.robotStatusLoading = false;
        if (response.state === 1) {
          this.robotList = response.data || [];
        } else {
          console.error('Failed to load robot status:', response.msg);
          this.robotList = [];
        }
      }).catch(error => {
        this.robotStatusLoading = false;
        console.error('Error loading robot status:', error);
        this.robotList = [];
      });
    },
    // 加载后端版本信息
    loadBackendVersion() {
      this.backendVersionLoading = true;
      this.backendVersionError = '';
      api.getData('system-server/platform/version').then(response => {
        if (response && response.state === 1) {
          const data = response.data || {};
          this.backendPlatformVersion = data.platformVersion || '';
          this.backendBuildTime = data.buildTime || '';
        } else {
          const msg = (response && response.msg) ? response.msg : '获取失败';
          this.backendVersionError = msg;
          this.backendPlatformVersion = '';
          this.backendBuildTime = '';
        }
      }).catch(error => {
        this.backendVersionError = (error && error.message) ? error.message : '网络错误';
        this.backendPlatformVersion = '';
        this.backendBuildTime = '';
      }).finally(() => {
        this.backendVersionLoading = false;
      });
    },
    // 从路由中查找指定名称的路由
    findRouteByName(name) {
      const routes = this.$router.options.routes;
      
      for (let i = 0; i < routes.length; i++) {
        const route = routes[i];
        if (route.name === name) {
          return route;
        }
        if (route.children && route.children.length > 0) {
          for (let j = 0; j < route.children.length; j++) {
            const child = route.children[j];
            if (child.name === name) {
              return {
                ...child,
                fullPath: route.path + '/' + child.path
              };
            }
          }
        }
      }
      return null;
    },
    // 从 sysMenulist 中查找菜单项
    findMenuInSysMenulist(name) {
      if (!this.sysMenulist || this.sysMenulist.length === 0) return null;
      
      for (let i = 0; i < this.sysMenulist.length; i++) {
        const menu = this.sysMenulist[i];
        if (menu.name === name) {
          return menu;
        }
        if (menu.children && menu.children.length > 0) {
          for (let j = 0; j < menu.children.length; j++) {
            if (menu.children[j].name === name) {
              return menu.children[j];
            }
          }
        }
      }
      return null;
    },
    // 从 localStorage 加载快捷菜单
    loadQuickMenus() {
      try {
        const stored = localStorage.getItem(this.storageKey);
        if (stored) {
          const menuNames = JSON.parse(stored);
          this.quickMenus = menuNames.map(name => {
            // 直接从 availableRoutes 查找，已经包含 sysMenulist 的标题
            const route = this.availableRoutes.find(r => r.name === name);
            return route ? {
              name: route.name,
              path: route.fullPath,
              title: route.title,
              isParent: route.isParent,
              children: route.children // 保存子菜单信息，用于也芬导航
            } : null;
          }).filter(m => m !== null);
        }
      } catch (e) {
        console.error('Failed to load quick menus:', e);
      }
    },
    // 保存快捷菜单到 localStorage
    saveQuickMenus() {
      try {
        const menuNames = this.quickMenus.map(m => m.name);
        localStorage.setItem(this.storageKey, JSON.stringify(menuNames));
      } catch (e) {
        console.error('Failed to save quick menus:', e);
        this.$Message.error(this.$translate('home_save_failed'));
      }
    },
    // 检查是否为快捷菜单
    isQuickMenu(name) {
      return this.quickMenus.some(m => m.name === name);
    },
    // 切换快捷菜单状态
    toggleQuickMenu(route) {
      const index = this.quickMenus.findIndex(m => m.name === route.name);
      if (index > -1) {
        // 移除菜单
        this.quickMenus.splice(index, 1);
      } else {
        // 添加菜单，检查数量限制
        if (this.quickMenus.length >= MAX_QUICK_MENUS) {
          this.$Message.warning(this.$translate('home_max_quick_menus_reached').replace('{max}', MAX_QUICK_MENUS));
          return;
        }
        this.quickMenus.push({
          name: route.name,
          path: route.fullPath,
          title: route.title, // route 已经包含 sysMenulist 的标题
          isParent: route.isParent,
          children: route.children // 保存子菜单信息，用于导航
        });
      }
      this.saveQuickMenus();
    },
    // 移除快捷菜单
    removeQuickMenu(name) {
      const index = this.quickMenus.findIndex(m => m.name === name);
      if (index > -1) {
        this.quickMenus.splice(index, 1);
        this.saveQuickMenus();
      }
    },
    // 获取菜单标题（支持多语言）
    getMenuTitle(menu) {
      if (typeof menu.title === 'string') {
        return menu.title;
      }
      if (typeof menu.title === 'object' && menu.title !== null) {
        return menu.title[this.lang] || menu.title['zh'] || menu.name;
      }
      return menu.title || menu.name;
    },
    // 获取路由标题（支持多语言）
    getRouteTitle(route) {
      // route.title 已经包含了 sysMenulist 的标题
      if (route.title) {
        if (typeof route.title === 'string') {
          return route.title;
        }
        if (typeof route.title === 'object' && route.title !== null) {
          return route.title[this.lang] || route.title['zh'] || route.name;
        }
      }
      return route.name;
    },
    // 导航到指定菜单：父级菜单自动导航到第一个子菜单
    navigateTo(menu) {
      // 如果是父级菜单（isParent=true），导航到第一个子菜单
      if (menu.isParent && menu.children && menu.children.length > 0) {
        const firstChild = menu.children[0];
        if (firstChild.name) {
          const route = this.findRouteByName(firstChild.name);
          if (route) {
            // 使用 fullPath 或 path，优先 fullPath
            const targetPath = route.fullPath || route.path;
            if (targetPath) {
              this.$router.push(targetPath);
              return;
            }
          }
        }
      }
      
      // 子菜单或其他，直接导航
      // 优先使用 fullPath，回退使用 path
      const targetPath = menu.fullPath || menu.path;
      if (targetPath) {
        this.$router.push(targetPath);
      }
    },
    // 根据权限过滤快捷菜单（基于 sysMenulist）
    filterQuickMenusByPermission() {
      // 获取当前 sysMenulist 中所有的菜单名称
      const availableMenuNames = [];
      if (this.sysMenulist && this.sysMenulist.length > 0) {
        this.sysMenulist.forEach(menu => {
          if (menu.name) availableMenuNames.push(menu.name);
          if (menu.children && menu.children.length > 0) {
            menu.children.forEach(child => {
              if (child.name) availableMenuNames.push(child.name);
            });
          }
        });
      }
      
      // 过滤掉不在 sysMenulist 中的菜单
      const filteredMenus = this.quickMenus.filter(menu => {
        return availableMenuNames.includes(menu.name);
      });
      
      // 如果有菜单被过滤掉了，更新并保存
      if (filteredMenus.length !== this.quickMenus.length) {
        this.quickMenus = filteredMenus;
        this.saveQuickMenus();
        
        // 提示用户有菜单因权限变化被移除
        if (filteredMenus.length < this.quickMenus.length) {
          this.$Message.info(this.$translate('home_menus_removed_due_to_permission'));
        }
      }
    },
  },
};
</script>
